var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-img',_vm._b({class:_vm.classes,style:(_vm.style),attrs:{"crossorigin":"anonymous","src":_vm.customs.src || _vm.customs.placeholder,"fluid":""}},'b-img',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }